import type { BuildElementIconCacheKey } from "./types";

export const buildElementIconCacheKey: BuildElementIconCacheKey = ({
  elementId,
  bbox,
}) => `${elementId}|${bbox.x1},${bbox.y1},${bbox.x2},${bbox.y2}`;
